import React from 'react'

const KitchenDetails = ({ color = '#676767' }: { color?: string }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.72656 1.08008V4.9079C1.72656 6.54202 3.05127 7.86673 4.68539 7.86673M7.64422 1.08008V4.9079C7.64422 6.54202 6.31951 7.86673 4.68539 7.86673M4.65612 1.08008V5.07437M4.68539 7.86673V18.9198M16.2734 18.9198L16.2734 1.08008C16.2734 1.08008 11.6443 1.08008 11.6443 9.80787V13.998H13.7676'
        stroke={color}
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default KitchenDetails
